<template>
  <div class="m-activity-add">
    <el-form v-if="baseInfoEdit" ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <div class="base-box">
        <div class="title">基本设置</div>
        <el-form-item label="活动名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入活动名称" class="input"  />
        </el-form-item>
        <el-form-item label="活动时间" prop="activityDate">
          <el-date-picker
            v-model="form.activityDate"
            type="datetimerange"
            range-separator=""
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动图片" prop="picUrl" >
          <UploadImg @getUploadFile="getUploadFile"  name="picUrl" :uploadUrl="form.picUrl" :width="400" desc="建议：上传750x290的jpg、png、jpeg图片"></UploadImg>
        </el-form-item>
        <el-form-item label="活动说明" prop="description" class="not-required">
          <el-input type="textarea" rows="6" v-model="form.description" placeholder="请输入活动说明" maxlength="500" show-word-limit />
        </el-form-item>
      </div>

      <div class="limiting-box">
        <div class="title">活动限制</div>
        <el-form-item label="触发场景" prop="scene">
          <el-radio-group v-model="form.scene" @change="onSceneChange" :disabled="isKeyEdit()">
            <el-radio label="AfterPay">支付成功页面</el-radio>
            <el-radio label="Register">注册</el-radio>
            <el-radio label="LotteryCenter">抽奖中心<!-- <span style="font-size: 10px;">（每天免费抽1次）</span> --></el-radio>
            <el-radio label="CouponDeal">券核销</el-radio>
            <auth-button v-if="form.type === 'Roulette'" auth="market:deductcoupon:template:read">
              <el-radio label="SupplierAfterPay">商品支付成功页</el-radio>
            </auth-button>
          </el-radio-group>
          <el-form-item  v-if="form.scene == 'LotteryCenter'" label="每天可免费抽" prop="freePrizeDraw" label-width="340px">
                <el-input v-model="form.freePrizeDraw"  placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 100px;" />
                <span style="line-height: 34px;" class="ml10"> 次</span>
           </el-form-item>
        </el-form-item>
        <div v-if="form.scene == 'LotteryCenter' || form.scene == 'CouponDeal'" class="help-box">
          <el-form-item label="分享助力" prop="help">
            <el-radio-group v-model="form.help">
              <el-radio :label="true">开启</el-radio>
              <el-radio :label="false">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="content">
            <div class="help-rule">
              <el-form-item label="每人每天可被助力" prop="helpNum" label-width="150px">
                <el-input v-model="form.helpNum" :disabled="isKeyEdit()" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 100px;" />
              </el-form-item>
              <el-form-item label="次，助力成功1次可获得" prop="helpRaffleNum" label-width="170px">
                <el-input v-model="form.helpRaffleNum" :disabled="isKeyEdit()" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 100px;" />
              </el-form-item>
              <span style="line-height: 34px;" class="ml10"> 次抽奖机会</span>
            </div>
            <el-form-item label="微信分享背景图" prop="wxBackGroundPicUrl" label-width="150px">
              <UploadImg @getUploadFile="getUploadFile" name="wxBackGroundPicUrl" :uploadUrl="form.wxBackGroundPicUrl" desc="建议：上传500*400的jpg、png、jpeg图片" :width="188"></UploadImg>
            </el-form-item>
            <el-form-item label="支付宝分享背景图" prop="aliBackGroundPicUrl" label-width="150px">
              <UploadImg @getUploadFile="getUploadFile" name="aliBackGroundPicUrl" :uploadUrl="form.aliBackGroundPicUrl" desc="建议：上传750*950的jpg、png、jpeg图片" :height="190"></UploadImg>
            </el-form-item>
            <el-form-item label="分享标题" prop="helpTitle" label-width="150px">
              <el-input v-model="form.helpTitle" placeholder="请输入" />
            </el-form-item>
          </div>
          <el-form-item label="积分兑换" prop="pointRedemption">
            <el-radio-group v-model="form.pointRedemption">
              <el-radio :label="true">开启</el-radio>
              <el-radio :label="false">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="content">
            <div class="help-rule">
              <el-form-item label="" prop="prPoint" label-width="30px">
                <el-input v-model="form.prPoint" :disabled="isKeyEdit()" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 100px;" />
              </el-form-item>
              <el-form-item label="积分兑换1次抽奖机会，每天可兑换" prop="prDailyLimitNum" label-width="240px">
                <el-input v-model="form.prDailyLimitNum" :disabled="isKeyEdit()" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 100px;" />
              </el-form-item>
              <span style="line-height: 34px;" class="ml10">次</span>
            </div>
          </div>
        </div>
        <el-form-item label="抽奖限制" prop="restriction" v-if="form.scene == 'AfterPay' || form.scene == 'Register'">
          <el-radio-group v-model="form.restriction">
            <el-radio :label="1">每日一次</el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="form.scene == 'SupplierAfterPay'">
          <el-form-item label="单日限制" prop="restriction_type">
            <el-radio-group v-model="form.restriction_type">
              <el-radio label="unlimited">无限制</el-radio>
              <el-radio label="limited">
                <div style="display: inline-block;">
                  <el-form-item label=" " prop="restriction" label-width="0">
                    <span>每人可抽上限 </span>
                    <el-input v-model="form.restriction"  placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 100px;" />
                    <span> 次</span>
                  </el-form-item>
                </div>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="次数总限制" prop="lotteryTotalLimit_type">
            <el-radio-group v-model="form.lotteryTotalLimit_type">
              <el-radio label="unlimited">无限制</el-radio>
              <el-radio label="limited">
                <div style="display: inline-block;">
                  <el-form-item label=" " prop="lotteryTotalLimit" label-width="0">
                    <span>用户总限抽 </span>
                    <el-input v-model="form.lotteryTotalLimit"  placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 100px;" />
                    <span> 次</span>
                  </el-form-item>
                </div>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="次数有效期" prop="lotteryTodayEffective">
            <el-radio-group v-model="form.lotteryTodayEffective">
              <el-radio :label="true">次日失效</el-radio>
              <el-radio :label="false">活动时间内有效</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        <el-form-item label="参与限制" prop="useRange">
          <el-radio-group v-model="form.useRange" :disabled="form.scene == 'SupplierAfterPay'">
            <el-radio label="Generic">全场通用</el-radio>
            <el-radio label="Mall">指定商场</el-radio>
            <el-radio label="Store" v-if="form.scene == 'AfterPay'">指定店铺</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.useRange === 'Mall'" :class="`mall-select-box`" prop="mallIds" label="" label-width="0">
          <el-select v-model="form.mallIds" placeholder="请选择商场" multiple collapse-tags filterable clearable>
            <el-option v-for="item in mallData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.useRange === 'Store'" :class="`store-select-box`" prop="storeIds" label="" label-width="0">
          <el-cascader
            v-model="form.storeIds"
            placeholder="请选择店铺"
            :options="storeTreeData"
            :props="storeCascaderProps"
            clearable
            collapse-tags
            :filterable="true"
            :show-all-levels="false"
          >
          </el-cascader>
        </el-form-item>
      </div>
    </el-form>

    <div v-else class="base-info">
      <div class="base-info-baseSet">
        <div class="title">基本设置</div>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动名称</el-col>
          <el-col :span="22" class="col-value">{{ form.name }}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动时间</el-col>
          <el-col :span="22" class="col-value">
            {{ form.startTime ? $moment(form.startTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
            {{ form.endTime ? ' - ' + $moment(form.endTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
          </el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动图片</el-col>
          <el-col :span="22" class="col-value">
            <div v-if="form.picUrl" class="logo-box" style="width: 400px; height: 150px;">
              <el-image v-if="form.picUrl" :src="form.picUrl" class="img" fit="contain" />
            </div>
            <span v-else>---</span>
          </el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动说明</el-col>
          <el-col :span="6" class="col-value white-space">{{ form.description }}</el-col>
        </el-row>
      </div>
      <div class="base-info-limitingSet">
        <div class="title">活动限制</div>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">触发场景</el-col>
          <el-col :span="22" class="col-value">{{ form.sceneName }}</el-col>
        </el-row>
        <div v-if="form.scene == 'LotteryCenter' || form.scene == 'CouponDeal'">
        <el-row class="row-info" v-if="form.sceneName == '抽奖中心'">
          <el-col :span="2" class="col-label">免费抽奖次数</el-col>
          <el-col :span="22" class="col-value">{{ form.freePrizeDraw }}</el-col>
        </el-row>
          <el-row class="row-info">
            <el-col :span="2" class="col-label">分享助力</el-col>
            <el-col :span="22" class="col-value">{{ form.help ? '开启' : '关闭' }}</el-col>
          </el-row>
          <el-row class="row-info" v-if="form.help">
            <el-col :span="2" class="col-label">-</el-col>
            <el-col :span="22" class="col-value">每人每天可被助力{{ form.helpNum }}次，助力成功1次可获得{{ form.helpRaffleNum }}次抽奖机会</el-col>
          </el-row>
          <el-row class="row-info">
            <el-col :span="2" class="col-label">微信分享背景图</el-col>
            <el-col :span="22" class="col-value" v-if="form.wxBackGroundPicUrl">
              <div class="logo-box wx">
                <el-image v-if="form.wxBackGroundPicUrl" :src="form.wxBackGroundPicUrl" class="img" fit="contain" />
              </div>
            </el-col>
            <el-col :span="22" class="col-value" v-else>---</el-col>
          </el-row>
          <el-row class="row-info">
            <el-col :span="2" class="col-label">支付宝分享背景图</el-col>
            <el-col :span="22" class="col-value" v-if="form.aliBackGroundPicUrl">
              <div class="logo-box ali">
                <el-image v-if="form.aliBackGroundPicUrl" :src="form.aliBackGroundPicUrl" class="img" fit="contain" />
              </div>
            </el-col>
            <el-col :span="22" class="col-value" v-else>---</el-col>
          </el-row>
          <el-row class="row-info">
            <el-col :span="2" class="col-label">分享标题</el-col>
            <el-col :span="22" class="col-value">{{ form.helpTitle || '---' }}</el-col>
          </el-row>
          <el-row class="row-info">
            <el-col :span="2" class="col-label">积分兑换</el-col>
            <el-col :span="22" class="col-value">{{ form.pointRedemption ? '开启' : '关闭' }}</el-col>
          </el-row>
          <el-row class="row-info" v-if="form.pointRedemption">
            <el-col :span="2" class="col-label">-</el-col>
            <el-col :span="22" class="col-value">{{ form.prPoint }}积分兑换1次抽奖机会，每天可兑换{{ form.prDailyLimitNum }}次</el-col>
          </el-row>
        </div>
        <template>
          <el-row class="row-info" v-if="form.scene == 'SupplierAfterPay'">
            <el-col :span="2" class="col-label">单日限制</el-col>
            <el-col :span="22" class="col-value">
              <span v-if="form.restriction_type == 'unlimited'">无限制</span>
              <span v-if="form.restriction_type == 'limited'">每人可抽上限 {{ form.restriction }} 次</span>
            </el-col>
          </el-row>
          <el-row class="row-info" v-if="form.scene == 'SupplierAfterPay'">
            <el-col :span="2" class="col-label">次数总限制</el-col>
            <el-col :span="22" class="col-value">
              <span v-if="form.lotteryTotalLimit_type == 'unlimited'">无限制</span>
              <span v-if="form.lotteryTotalLimit_type == 'limited'">用户总限抽 {{ form.lotteryTotalLimit }} 次</span>
            </el-col>
          </el-row>
          <el-row class="row-info">
            <el-col :span="2" class="col-label">次数有效期</el-col>
            <el-col :span="22" class="col-value">
              <span v-if="form.lotteryTodayEffective === false">活动时间内有效</span>
              <span v-else-if="form.lotteryTodayEffective === true">次日失效</span>
              <span v-else>---</span>
            </el-col>
          </el-row>
        </template>
        <el-row class="row-info" v-if="form.scene == 'AfterPay' || form.scene == 'Register'">
          <el-col :span="2" class="col-label">抽奖限制</el-col>
          <el-col :span="22" class="col-value">
            <span v-if="form.restriction == 1">每日一次</span>
          </el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">参与限制</el-col>
          <el-col :span="22" class="col-value">{{ form.useRangeName }}</el-col>
        </el-row>
      </div>
    </div>

    <div v-if="baseInfoEdit" class="button-box">
      <el-button @click="onCancel" class="mr20">取消</el-button>
      <el-button type="primary" @click="onNextStep" :loading="submitLoading">下一步</el-button>
    </div>
    <div v-else-if="isCanEdit" class="button-box">
      <auth-button auth="market:activity:update">
        <el-button type="primary" @click="onEdit" :loading="submitLoading" >编辑</el-button>
      </auth-button>
    </div>
    <el-divider />

    <!-- 奖品设置 -->
    <div class="prizes-set-box" v-if="!baseInfoEdit">
      <AddPrizes
        :baseInfo="form"
        :isCanEdit="isCanEdit"
        :mallData="mallData"
      />
    </div>

    <!-- 中奖记录 -->
    <div class="winning-record" v-if="$route.query.page == 'detail'">
      <el-divider />
      <div class="title">中奖记录</div>
      <WainingRecord></WainingRecord>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import UploadImg from '@/components/UploadImg/index'
import AddPrizes from './components/addPrizes.vue'
import WainingRecord from './components/winningRecord.vue'
import { api_postActivityAdd, api_postActivityUpdate, api_getActivityBaseInfo } from '@/api/market'
import { api_getListPortrait } from '@/api/member' // 会员
import { api_getConfig, api_postFileUpload } from "@/api/common";

export default {
  name: "marketActivityListAdd",
  components: {
    AuthButton,
    UploadImg,
    AddPrizes,
    WainingRecord
  },
  data() {
    // 校验活动图片
    const checkPicUrl = (rule, value, callback) => {
      if (!this.form.picUrl) {
        callback(new Error('请上传活动图片'))
      } else {
        callback()
      }
    }

    // 校验分享助力
    const checkHelpRequired = (rule, value, callback) => {
      if (this.form.help && (!value)) {
        callback(new Error('请输入'))
      } else {
        callback()
      }
    }

    // 校验积分兑换
    const checkPointRequired = (rule, value, callback) => {
      if (this.form.pointRedemption && !value) {
        callback(new Error('请输入'))
      } else {
        callback()
      }
    }

    // 校验单日限制
    const checkRestriction = (rule, value, callback) => {
      if (this.form.restriction_type == 'limited' && !value) {
        callback(new Error('请输入'))
      } else if (this.form.lotteryTotalLimit && (value * 1 > this.form.lotteryTotalLimit * 1)) {
        callback(new Error('单日限制不能大于次数总限制'))
      } else {
        callback()
      }
    }

    // 校验次数总限制
    const checkTotalRestriction = (rule, value, callback) => {
      if (this.form.lotteryTotalLimit_type == 'limited' && !value) {
        callback(new Error('请输入'))
      } else {
        callback()
      }
    }

    return {
      isAdmin: false, // 是否是超级管理员
      submitLoading: false,
      baseInfoEdit: true, // 基本信息是否是编辑状态
      isCanEdit: true, // 活动是否可编辑
      form: {
        type: '', // 活动类型
        useRange: '',
      },
      rules: {
        name: [{ required: true, message: '请输入活动名称' }],
        activityDate: [{ required: true, message: '请选择活动时间' }],
        picUrl: [{ validator: checkPicUrl }],
        scene: [{ required: true, message: '请选择触发场景' }],
        help: [{ required: true, message: '请选择' }],
        freePrizeDraw:[{ required: true, message: '请输入' }],
        helpNum: [{ validator: checkHelpRequired }],
        helpRaffleNum: [{ validator: checkHelpRequired }],
        helpTitle: [{ validator: checkHelpRequired }],
        pointRedemption: [{ required: true, message: '请选择' }],
        prPoint: [{ validator: checkPointRequired }],
        prDailyLimitNum: [{ validator: checkPointRequired }],
        restriction: [{ validator: checkRestriction }],
        lotteryTotalLimit: [{ validator: checkTotalRestriction }],
        restriction_type: [{ required: true, message: '请选择次数限制' }],
        lotteryTotalLimit_type: [{ required: true, message: '请选择次数限制' }],
        lotteryTodayEffective: [{ required: true, message: '请选择次数有效期' }],
        useRange: [{ required: true, message: '请选择参与限制' }],
        mallIds: [{ required: true, message: '请选择商场' }],
        storeIds: [{ required: true, message: '请选择店铺' }],
      },

      sceneObjData: {
        'AfterPay': '支付成功页面',
        'LotteryCenter': '抽奖中心',
        'Register': '注册',
        'CouponDeal': '券核销',
        'SupplierAfterPay': '商品支付成功页',
      }, // 触发场景枚举
      useRangeObjData: {
        'Generic': '全场通用',
        'Mall': '指定商场',
        'Store': '指定店铺',
      }, // 参与限制枚举
      portrayalData: [], // 画像数据
      mallData: [], // 商场数据
      storeTreeData: [], // 店铺级联框树形数据
      storeCascaderProps: {
        multiple: true,
        value: "id",
        label: "name",
        emitPath: false,
      }, // 店铺级联框配置项
    };
  },
  created() {
    this.form.type = this.$route.query.type
    this.isAdmin = JSON.parse(localStorage.getItem('USER_INFO')).admin
    // this.getPortrayalData() // 获取画像数据
    this.getConfigData() // 获取config数据（商场、店铺级联框）
    if (this.$route.query.id) {
      this.getBaseInfoData() // 获取活动基本信息数据
    }
  },
  methods: {
    // 获取活动基本信息数据
    async getBaseInfoData() {
      const { id, page } = this.$route.query
      const res = await api_getActivityBaseInfo({id: id})
      console.log('基本信息res: ', res);

      this.form = {
        ...res,
        activityDate: [res.startTime, res.endTime],
        sceneName: res.scene ? this.sceneObjData[res.scene] : '', // 触发场景name
        useRangeName: res.useRange ? this.useRangeObjData[res.useRange] : '', // 参与限制name
        restriction_type: res.restriction || res.restriction === 0 ? 'limited' : 'unlimited',
        lotteryTotalLimit_type: res.lotteryTotalLimit || res.lotteryTotalLimit === 0 ? 'limited' : 'unlimited',
      }

      if (( res.status == 'Ended' ) && page == 'detail') {
        this.isCanEdit = false // 查看详情时，已结束状态不能编辑
      }
      this.baseInfoEdit = false
    },
    // 判断该字段是否可编辑
    isKeyEdit(){
         const {page} = this.$route.query
        if(page=="detail"){
          return true
        }else{
          return false
        }
    },
    // 获取画像数据
    async getPortrayalData() {
      const res = await api_getListPortrait({limit: 10000, offset: 0})
      this.portrayalData = res.list
    },

    // 获取config数据（商场、店铺级联框）
    async getConfigData() {
      let {mall, storeThreeLevel} = await api_getConfig(['mall', 'storeThreeLevel'])
      this.mallData = mall
      this.storeTreeData = storeThreeLevel
    },

    // 触发场景改变
    onSceneChange(value) {
      console.log('value: ', value);
      let arr = ['help', 'helpNum', 'helpRaffleNum', 'wxBackGroundPicUrl', 'helpTitle', 'pointRedemption', 'prPoint', 'prDailyLimitNum', 'restriction', 'lotteryTodayEffective']
      for (let i = 0; i < arr.length; i++) {
        delete this.form[arr[i]]
      }
      if (value == 'SupplierAfterPay') {
        this.form.useRange = 'Generic' // 商品支付成功页场景 参与限制只可选择全场通用
      } else {
        this.form.useRange = ''
      }
    },

    // 点击基本信息的编辑按钮
    onEdit() {
      this.baseInfoEdit = true
      window.scrollTo(0, 0)
    },

    // 点击下一步按钮 提交基本信息
    onNextStep() {
      this.$refs.form.validate(async (valid) => {
        console.log('valid: ', valid);
        if (valid) {
          // this.submitLoading = true
          try {
            let { activityDate } = this.form
            let params = {
              ...this.form,
              startTime: activityDate && activityDate[0] ? activityDate[0] : null,
              endTime: activityDate && activityDate[1] ? activityDate[1] : null,
            }

            !params.id && (params.disable = false) // 创建活动时默认状态
            delete params.activityDate // 删除活动时间原始数据
            params.restriction_type == 'unlimited' && delete params.restriction
            params.lotteryTotalLimit_type == 'unlimited' && delete params.lotteryTotalLimit
            delete params.restriction_type
            delete params.lotteryTotalLimit_type

            if (this.form.picUrl && this.form.picUrl.size) {
              const { key } = await api_postFileUpload(this.form.picUrl, 'Active')
              params.picUrl = key
            }

            if (this.form.wxBackGroundPicUrl && this.form.wxBackGroundPicUrl.size) {
              const { key } = await api_postFileUpload(this.form.wxBackGroundPicUrl, 'Active')
              params.wxBackGroundPicUrl = key
            }

            if (this.form.aliBackGroundPicUrl && this.form.aliBackGroundPicUrl.size) {
              const { key } = await api_postFileUpload(this.form.aliBackGroundPicUrl, 'Active')
              params.aliBackGroundPicUrl = key
            }

            console.log('params: ', params);
            // return

            let res = params.id ? await api_postActivityUpdate(params) : await api_postActivityAdd(params)
            console.log('res: ', res);
            this.$router.push({
              query: {
                ...this.$route.query,
                id: res.id
              }
            })
            this.getBaseInfoData()
            this.submitLoading = false
          } catch (err) {
            console.log('err: ', err);
            this.submitLoading = false
          }
        }
      })
    },

    // 图片上传事件
    getUploadFile (file, name) {
      this.form[name] = file
    },

    // 点击取消
    onCancel() {
      if (this.$route.query.id) {
        this.baseInfoEdit = false
        window.scrollTo(0, 0)
      } else {
        this.$router.back(-1)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-activity-add {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;

  .limiting-box {
    margin-top: 50px;

    .mall-select-box {
      margin-left: 200px;

      &.left2 {
        margin-left: 100px;
      }
    }

    .store-select-box {
      margin-left: 300px;
      &.left2 {
        margin-left: 200px;
      }
    }
  }

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .help-box {

    .content {
      margin-left: 70px;
      .help-rule {
        display: flex;
      }

      .el-form-item__label {
        text-align: left !important;
      }
    }
  }

  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;

      &.white-space {
        white-space: pre-wrap;
      }

      .logo-box {
        width: 150px;
        height: 150px;
        border: 1px solid #ccc;
        border-radius: 2px;

        &.wx {
          width: 188px;
        }

        &.ali {
          height: 190px;
        }

        .img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .winning-record {
    margin-top: 60px;

    .el-divider {
      margin-bottom: 20px;
    }
  }


  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }

    .title-remark {
      color: #666666;
      font-size: 14px;
    }
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
  }

  .button-box{
    text-align: right;
  }
}
</style>
